import type { ComponentPropsWithoutRef } from 'react'
import cc from 'classcat'

import { useTranslate } from '../../utils/translate'

export interface BannerProps extends ComponentPropsWithoutRef<'div'> {
  readonly type: 'info' | 'success' | 'warning' | 'danger'
  readonly onClose?: () => void
}

export function Banner({ type, onClose, className, children, ...rest }: BannerProps) {
  const t = useTranslate('interface')
  const dismissLabel = t('components.bannerComponent.dismissButton.label')

  return (
    <div {...rest} className={cc(['banner', `banner-${type}`, className])}>
      {children}
      {onClose && (
        <button
          type="button"
          title={dismissLabel}
          aria-label={dismissLabel}
          className="banner-close"
          onClick={onClose}
        />
      )}
    </div>
  )
}
